var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable, makeObservable } from 'mobx';
import API from '../util/ApiUtil';
class ProductLimitsStore {
    constructor() {
        Object.defineProperty(this, "productLimitsEntity", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                productLimits: { financialLimit: null, freeFinancialLimit: null },
                status: 'UNINITIALIZED'
            }
        });
        Object.defineProperty(this, "handleSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (response) => {
                this.productLimitsEntity.productLimits = response.data;
                this.productLimitsEntity.status = 'FETCHED';
            }
        });
        Object.defineProperty(this, "handleError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (error) => {
                console.error(error);
                this.productLimitsEntity.status = 'ERROR';
                this.productLimitsEntity.productLimits = { financialLimit: null, freeFinancialLimit: null };
            }
        });
        Object.defineProperty(this, "shouldFetchProductLimits", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return ['UNINITIALIZED', 'ERROR'].includes(this.productLimitsEntity.status);
            }
        });
        makeObservable(this);
    }
    async fetchProductLimits() {
        if (!this.shouldFetchProductLimits()) {
            return Promise.resolve();
        }
        this.productLimitsEntity.status = 'FETCHING';
        return API.get('/limits/product-limits').then(this.handleSuccess).catch(this.handleError);
    }
    isFetching() {
        return ['UNINITIALIZED', 'FETCHING'].includes(this.productLimitsEntity.status);
    }
    hasError() {
        return ['ERROR'].includes(this.productLimitsEntity.status);
    }
    getFreeProductLimit() {
        return this.productLimitsEntity.productLimits.freeFinancialLimit;
    }
    getProductLimit() {
        return this.productLimitsEntity.productLimits.financialLimit;
    }
}
__decorate([
    observable
], ProductLimitsStore.prototype, "productLimitsEntity", void 0);
__decorate([
    action.bound
], ProductLimitsStore.prototype, "fetchProductLimits", null);
__decorate([
    action.bound
], ProductLimitsStore.prototype, "handleSuccess", void 0);
__decorate([
    action.bound
], ProductLimitsStore.prototype, "handleError", void 0);
export default ProductLimitsStore;
